import * as React from 'react';
import { inject, observer } from 'mobx-react';
import styled from 'styled-components';
import { Tooltip } from 'react-tippy';
import { colors } from 'kaizen-ui-colors/lib';
import { IStore } from '../../domain/store/IStore';
import config from '../../config';

interface IProps {
  store?: IStore;
}

const AppNavMenu = styled.div`
  display: none;

  @media (min-width: 576px) {
    display: block;
    min-width: 48px;
  }
`;

const Divider = styled.div`
  border-right: 1px solid ${colors.slate__4c566c};
  height: 32px;
`;

@inject('store')
@observer
export default class HeaderBar extends React.Component<IProps, {}> {
  private store: IStore;

  constructor(props: IProps) {
    super(props);
    this.store = props.store!;
  }

  public render() {
    const { currentUserStore, kaizenLabServiceStore, organizationStore } = this.store;
    const serviceList = kaizenLabServiceStore.getOtherServices(organizationStore.selectedOrganizationId);

    return (
      <kz-app-toolbar>
        <AppNavMenu>
          {serviceList.length > 0 ? (
            <kz-app-nav-menu>
              {serviceList.map(service => (
                <kz-app-nav-menu-item
                  key={service.label}
                  app-name={service.name}
                  description={service.description}
                  url={service.url}
                />
              ))}
            </kz-app-nav-menu>
          ) : null}
        </AppNavMenu>
        <kz-app-title version={config.appVersion} release-stage="beta">
          Round Monitor
        </kz-app-title>
        <Divider />
        <Tooltip title="ヘルプ" style={{ lineHeight: 0 }}>
          <a
            style={{ margin: '0 16px', color: '#fff' }}
            href={config.help_page_url}
            target="_blank"
            rel="noreferrer noopener"
          >
            <kz-icon-help-circle />
          </a>
        </Tooltip>
        {currentUserStore.currentUser ? <Divider style={{ marginRight: '16px' }} /> : null}
        <div style={{ lineHeight: 0 }}>
          {currentUserStore.currentUser ? (
            currentUserStore.currentUser.profileImageUrl ? (
              <kz-avatar
                src={currentUserStore.currentUser.profileImageUrl}
                username={currentUserStore.currentUser.username}
              />
            ) : (
              <kz-icon-user-circle />
            )
          ) : null}
        </div>
      </kz-app-toolbar>
    );
  }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/presentation/component/HeaderBar.tsx